function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getMainRangeChannel, getSecondaryRangeChannel, getSizeChannel, getVgPositionChannel } from '../../../channel';
import { isFieldOrDatumDef } from '../../../channeldef';
import * as log from '../../../log';
import { isRelativeBandSize } from '../../../mark';
import { getMarkStyleConfig } from '../../common';
import { getOffset } from './offset';
import { vgAlignedPositionChannel } from './position-align';
import { pointPosition, pointPositionDefaultRef } from './position-point';
import * as ref from './valueref';
/**
 * Utility for area/rule position, which can be either point or range.
 * (One of the axes should be point and the other should be range.)
 */

export function pointOrRangePosition(channel, model, _ref) {
  var defaultPos = _ref.defaultPos,
      defaultPos2 = _ref.defaultPos2,
      range = _ref.range;

  if (range) {
    return rangePosition(channel, model, {
      defaultPos: defaultPos,
      defaultPos2: defaultPos2
    });
  }

  return pointPosition(channel, model, {
    defaultPos: defaultPos
  });
}
export function rangePosition(channel, model, _ref2) {
  var defaultPos = _ref2.defaultPos,
      defaultPos2 = _ref2.defaultPos2;
  var markDef = model.markDef,
      config = model.config;
  var channel2 = getSecondaryRangeChannel(channel);
  var sizeChannel = getSizeChannel(channel);
  var pos2Mixins = pointPosition2OrSize(model, defaultPos2, channel2);
  var vgChannel = pos2Mixins[sizeChannel] ? // If there is width/height, we need to position the marks based on the alignment.
  vgAlignedPositionChannel(channel, markDef, config) : // Otherwise, make sure to apply to the right Vg Channel (for arc mark)
  getVgPositionChannel(channel);
  return _objectSpread(_objectSpread({}, pointPosition(channel, model, {
    defaultPos: defaultPos,
    vgChannel: vgChannel
  })), pos2Mixins);
}
/**
 * Return encode for x2, y2.
 * If channel is not specified, return one channel based on orientation.
 */

function pointPosition2OrSize(model, defaultPos, channel) {
  var _position2orSize;

  var encoding = model.encoding,
      mark = model.mark,
      markDef = model.markDef,
      stack = model.stack,
      config = model.config;
  var baseChannel = getMainRangeChannel(channel);
  var sizeChannel = getSizeChannel(channel);
  var vgChannel = getVgPositionChannel(channel);
  var channelDef = encoding[baseChannel];
  var scaleName = model.scaleName(baseChannel);
  var scale = model.getScaleComponent(baseChannel);
  var offset = channel in encoding || channel in markDef ? getOffset(channel, model.markDef) : getOffset(baseChannel, model.markDef);

  if (!channelDef && (channel === 'x2' || channel === 'y2') && (encoding.latitude || encoding.longitude)) {
    var vgSizeChannel = getSizeChannel(channel);
    var size = model.markDef[vgSizeChannel];

    if (size != null) {
      return _defineProperty({}, vgSizeChannel, {
        value: size
      });
    } else {
      return _defineProperty({}, vgChannel, {
        field: model.getName(channel)
      });
    }
  }

  var valueRef = position2Ref({
    channel: channel,
    channelDef: channelDef,
    channel2Def: encoding[channel],
    markDef: markDef,
    config: config,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    offset: offset,
    defaultRef: undefined
  });

  if (valueRef !== undefined) {
    return _defineProperty({}, vgChannel, valueRef);
  } // TODO: check width/height encoding here once we add them
  // no x2/y2 encoding, then try to read x2/y2 or width/height based on precedence:
  // markDef > config.style > mark-specific config (config[mark]) > general mark config (config.mark)


  return position2orSize(channel, markDef) || position2orSize(channel, (_position2orSize = {}, _defineProperty(_position2orSize, channel, getMarkStyleConfig(channel, markDef, config.style)), _defineProperty(_position2orSize, sizeChannel, getMarkStyleConfig(sizeChannel, markDef, config.style)), _position2orSize)) || position2orSize(channel, config[mark]) || position2orSize(channel, config.mark) || _defineProperty({}, vgChannel, pointPositionDefaultRef({
    model: model,
    defaultPos: defaultPos,
    channel: channel,
    scaleName: scaleName,
    scale: scale
  })());
}

export function position2Ref(_ref7) {
  var channel = _ref7.channel,
      channelDef = _ref7.channelDef,
      channel2Def = _ref7.channel2Def,
      markDef = _ref7.markDef,
      config = _ref7.config,
      scaleName = _ref7.scaleName,
      scale = _ref7.scale,
      stack = _ref7.stack,
      offset = _ref7.offset,
      defaultRef = _ref7.defaultRef;

  if (isFieldOrDatumDef(channelDef) && stack && // If fieldChannel is X and channel is X2 (or Y and Y2)
  channel.charAt(0) === stack.fieldChannel.charAt(0)) {
    return ref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
      suffix: 'start'
    }, {
      offset: offset
    });
  }

  return ref.midPointRefWithPositionInvalidTest({
    channel: channel,
    channelDef: channel2Def,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    markDef: markDef,
    config: config,
    offset: offset,
    defaultRef: defaultRef
  });
}

function position2orSize(channel, markDef) {
  var sizeChannel = getSizeChannel(channel);
  var vgChannel = getVgPositionChannel(channel);

  if (markDef[vgChannel] !== undefined) {
    return _defineProperty({}, vgChannel, ref.widthHeightValueOrSignalRef(channel, markDef[vgChannel]));
  } else if (markDef[channel] !== undefined) {
    return _defineProperty({}, vgChannel, ref.widthHeightValueOrSignalRef(channel, markDef[channel]));
  } else if (markDef[sizeChannel]) {
    var dimensionSize = markDef[sizeChannel];

    if (isRelativeBandSize(dimensionSize)) {
      log.warn(log.message.relativeBandSizeNotSupported(sizeChannel));
    } else {
      return _defineProperty({}, sizeChannel, ref.widthHeightValueOrSignalRef(channel, dimensionSize));
    }
  }

  return undefined;
}